import { AxiosError } from 'axios'

type ApiErrorBody = {
  message?: string
  errors?: string[]
  errorMessages?: string[]
}

const joinMessages = (values: string[] | undefined): string | undefined => {
  if (!Array.isArray(values)) {
    return undefined
  }
  return values.filter(value => typeof value === 'string' && value.trim() !== '').join('\n') || undefined
}

export const extractApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as AxiosError<ApiErrorBody>)?.response?.data
  return joinMessages(data?.errors) || joinMessages(data?.errorMessages) || data?.message || fallback
}
